import { useRef } from 'react'

/**
 * Stable per-row keys for an editable add/remove list. Keying such a list by
 * index misassociates input focus / DOM state when an item is removed mid-list;
 * this hands out an id per row instead. The while-loop re-syncs length on every
 * render, so `add` needs no bookkeeping — but `removeAt(i)` MUST be called on
 * remove so the correct key is dropped (not merely the tail).
 */
export function useStableKeys(length: number, prefix: string) {
  const seq = useRef(0)
  const keys = useRef<string[]>([])
  while (keys.current.length < length) keys.current.push(`${prefix}-${seq.current++}`)
  if (keys.current.length > length) keys.current = keys.current.slice(0, length)
  return {
    keys: keys.current,
    removeAt: (index: number) => keys.current.splice(index, 1),
  }
}
